export function generateSlugFromText(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .substring(0, 100);
}

export function validateUsernameSlug(slug: string): { valid: boolean; error?: string } {
  if (!slug || slug.length === 0) {
    return { valid: false, error: 'Username mag niet leeg zijn' };
  }

  if (slug.length < 3) {
    return { valid: false, error: 'Username moet minimaal 3 karakters zijn' };
  }

  if (slug.length > 30) {
    return { valid: false, error: 'Username mag maximaal 30 karakters zijn' };
  }

  if (!/^[a-z]/.test(slug)) {
    return { valid: false, error: 'Username moet beginnen met een letter' };
  }

  if (!/^[a-z0-9-]+$/.test(slug)) {
    return { valid: false, error: 'Username mag alleen letters, cijfers en streepjes bevatten' };
  }

  const reservedWords = [
    'admin', 'api', 'blog', 'auth', 'login', 'logout', 'register',
    'settings', 'profile', 'account', 'dashboard', 'user', 'users',
    'public', 'private', 'static', 'assets', 'images', 'files',
    'help', 'support', 'contact', 'about', 'terms', 'privacy'
  ];

  if (reservedWords.includes(slug.toLowerCase())) {
    return { valid: false, error: 'Deze username is gereserveerd' };
  }

  return { valid: true };
}

export function generateUsernameSuggestions(firstName: string, companyName: string): string[] {
  const suggestions: string[] = [];

  const firstNameSlug = generateSlugFromText(firstName);
  const companySlug = generateSlugFromText(companyName);

  if (firstNameSlug) {
    suggestions.push(firstNameSlug);
  }

  if (companySlug) {
    suggestions.push(companySlug);
  }

  if (firstNameSlug && companySlug && firstNameSlug !== companySlug) {
    suggestions.push(`${firstNameSlug}-${companySlug}`);
  }

  return suggestions.filter(s => {
    const validation = validateUsernameSlug(s);
    return validation.valid;
  }).slice(0, 3);
}

export async function checkUsernameAvailability(
  slug: string,
  supabase: any,
  currentUserId?: string
): Promise<{ available: boolean; error?: string }> {
  const validation = validateUsernameSlug(slug);
  if (!validation.valid) {
    return { available: false, error: validation.error };
  }

  try {
    let query = supabase
      .from('users')
      .select('id')
      .eq('username_slug', slug);

    if (currentUserId) {
      query = query.neq('id', currentUserId);
    }

    const { data, error } = await query.maybeSingle();

    if (error) {
      console.error('Error checking username availability:', error);
      return { available: false, error: 'Er ging iets mis bij het controleren' };
    }

    if (data) {
      return { available: false, error: 'Deze username is al in gebruik' };
    }

    return { available: true };
  } catch (error) {
    console.error('Error checking username availability:', error);
    return { available: false, error: 'Er ging iets mis bij het controleren' };
  }
}
